import { BallPitOverlay } from "@playlive/overlay-core/overlays/ball-pit";
import { useContext, useEffect, useState } from "preact/hooks";
import boomGif from "@/assets/overlays/ball-pit/boom.gif";
import LinkSetup from "@/components/overlays/social/link-setup/link-setup.jsx";
import ScaledOverlayWrapper from "@/components/overlays/wrapper/scaled-overlay-wrapper.jsx";
import CharitySection from "@/components/shared/charity-section.jsx";
import useTiltifyConfig from "@/hooks/useTiltifyConfig.js";
import useTwitchConfig from "@/hooks/useTwitchConfig.js";
import { buildCustomizedURL, getAssetImageUrl, isYes } from "@/util/common.js";
import { ProductContext } from "../../../context/productContext.js";
import CustomizeArtSpaceBallPit from "../shared/art-ball-space-pit/customize-art-space-ball-pit.jsx";
import useArtSpaceOverlayConfig from "./art-space-overlay.config.js";

export default function ArtSpaceOverlayPage() {
  const { config, setConfigState, resetToDefault } = useArtSpaceOverlayConfig();
  const overlayInfo = useContext(ProductContext);
  const tiltifyConfig = useTiltifyConfig();
  const twitchConfig = useTwitchConfig();
  const [rate, setRate] = useState(10);
  const useBetaOverlays = isYes(import.meta.env.VITE_BETA_OVERLAYS || "no");
  const overlayURL = buildCustomizedURL({
    config: {
      ...config,
      ...twitchConfig,
      ...tiltifyConfig,
    },
    urlBase: useBetaOverlays ? "overlays/art-space" : "art-space",
    addCharityType: true,
  });

  const [demoDonations, setDemoDonations] = useState([
    {
      id: "five",
      donor_name: "Andy Smith",
      completed_at: "",
      amount: {
        value: "5",
      },
    },
    {
      id: "ten",
      donor_name: "John Smith",
      completed_at: "",
      amount: {
        value: "10",
      },
    },
    {
      id: "hundred",
      donor_name: "Anonymous",
      completed_at: "",
      amount: {
        value: "100",
      },
    },
    {
      id: "thousand",
      donor_name: "Jay L.",
      completed_at: "",
      amount: {
        value: "1000",
      },
    },
    {
      id: "ten-thousand",
      donor_name: "EpicGamer72",
      completed_at: "",
      amount: {
        value: "10000",
      },
    },
  ]);

  useEffect(() => {
    let timeout;
    const generateRandom = (max, min) => {
      return Math.random() * (max - min) + min;
    };

    const generateRandomDonation = () => {
      const amountValue = `${generateRandom(1000, 10)}`;

      return {
        id: window.crypto.randomUUID(),
        donor_name: `Anonymous ${parseInt(amountValue, 10)}`,
        completed_at: "",
        amount: {
          value: amountValue,
        },
      };
    };

    function generateTimeout() {
      timeout = setTimeout(() => {
        setDemoDonations(() => [generateRandomDonation()]);
        generateTimeout();
      }, 1000 * rate);
    }

    generateTimeout();

    return () => {
      clearTimeout(timeout);
    };
  }, [rate]);

  return (
    <div className="w-full overflow-x-hidden">
      <div className="flex flex-col overflow-x-hidden">
        <div className="example_overlay select-none overflow-x-hidden w-full">
          <ScaledOverlayWrapper allowScaling={false} addPadding={false} defaultScale={"scale-100"}>
            <BallPitOverlay
              type={config.ballType}
              startSize={config.startSize / 2}
              showNames={false}
              donations={demoDonations}
              maxBalls={config.maxBalls}
              mass={config.mass}
              density={config.density}
              friction={config.friction}
              frictionStatic={config.frictionStatic}
              frictionAir={config.frictionAir}
              maxAmount={config.maxAmount}
              maxScale={config.maxScale / 20}
              minAmount={config.minAmount}
              scaleSize={isYes(config.scaleSize)}
              previewScaleSize={0.9}
              clampVelocity={config.clampVelocity}
              clampAngularSpeed={config.clampAngularSpeed}
              explosionGifURL={getAssetImageUrl(boomGif)}
              explosionForceMagnitude={Number(config.explosionForceMagnitude)}
              randomColors={false}
            />
          </ScaledOverlayWrapper>
        </div>

        <div className="w-full mb-4">
          <CustomizeArtSpaceBallPit
            setConfigState={setConfigState}
            config={config}
            resetToDefault={resetToDefault}
            setRate={setRate}
            rate={rate}
            type="art"
          />
          <CharitySection onChange={setConfigState} charityType={config.charityType} />

          <LinkSetup
            charityType={config.charityType}
            obsDimensions={overlayInfo.obsDimensions}
            overlayName={overlayInfo.name}
            overlayURL={overlayURL}
            showCopyDemoModeLinkButton
          />
        </div>
      </div>
    </div>
  );
}
